// @flow
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Row, Col, Grid } from 'react-flexbox-grid';

import styles from './reportsView.css';
import ReportSidebar from '../../ReportSidebar';
import ReportDisplay from '../../ReportDisplay';
import ReportAssistanceCard from '../../ReportAssistanceCard';


// type ReportsViewPropTypes = {
// };

const ReportsView = () => (
  <Grid className={styles.reportsContainer}>
    <Row style={{ height: '100%' }}>
      <Col xs={3} className={styles.reportsSidebar}>
        <ReportSidebar />
      </Col>
      <Col xs={9}>
        <ReportDisplay />
      </Col>
    </Row>
  </Grid>
);

export default connect(
  undefined,
  undefined,
)(withRouter(ReportsView));



// WEBPACK FOOTER //
// ./src/scripts/components/views/BackendReportsView/index.jsx